import { connect, getSocket } from "./index";

function ensureSocketConnection() {
  const socket = getSocket();

  if (!socket.connected && !socket.connecting) {
    console.log("🔄 Reconectando socket após retorno ao app...");
    connect();
  }
}

export function initSocketWatcher() {
  // Quando a aba volta a ser visível
  document.addEventListener("visibilitychange", () => {
    if (document.visibilityState === "visible") {
      ensureSocketConnection();
    }
  });

  // Quando a janela volta a ter foco
  window.addEventListener("focus", () => {
    ensureSocketConnection();
  });
}
